import ReimbursementDetailPanel from "./reimbursementDetailPanel.container";

export default ReimbursementDetailPanel;